const BASE_URL = process.env.baseURL;
export default {
  login: `${BASE_URL}account/authenticate/`,
  contacts: `${BASE_URL}contacts/available/`,
  deals: `${BASE_URL}tickets/shared`,
};



// WEBPACK FOOTER //
// ./src/config/urls.js